// Import: Middleware Action & Custom Types
import { CLEAN_CREATE_INCODE_LINKS, CLEAN_CREATE_INCODE_LINKS_ERROR } from '_models/redux/types';

// Action function
export const cleanCreateIncodeLinks = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_CREATE_INCODE_LINKS,
    });
  } catch (e) {
    dispatch({
      payload: undefined,
      type: CLEAN_CREATE_INCODE_LINKS_ERROR,
    });
  }
};
